import { render, staticRenderFns } from "./Alumni.vue?vue&type=template&id=477c4288&scoped=true&"
import script from "@/scripts/Alumni/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Alumni/index.js?vue&type=script&lang=js&"
import style0 from "./Alumni.vue?vue&type=style&index=0&id=477c4288&lang=scss&scoped=true&"
import style1 from "./Alumni.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Alumni.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c4288",
  null
  
)

export default component.exports